import type { PublicationCode } from '@/scopes/common/domain/types';
import type { Usp } from '../../pages/SearchPage/components/Results/Usps';

const DEFAULT_FILTER_VALUES: Record<string, Record<string, string | string[]>> = {
  SZ: {
    duration: ['8-11'],
  },
  KZ: {
    duration: ['8-8'],
  },
  QZ: {
    duration: ['8-8'],
  },
  FZ: {
    duration: ['8-9'],
  },
  FS: {
    duration: ['8-11'],
  },
  BZ: {
    duration: ['8-11'],
  },
};

// TODO check if we can unify this domain policy with the one in `scopes/search/quick-search/domain/policies/publicationCodes.ts`
export function getDefaultFilterValues(publicationCode: PublicationCode) {
  return DEFAULT_FILTER_VALUES[publicationCode];
}

const SEARCH_PAGE_USPS: Record<string, string[]> = {
  SZ: ['/laagste-prijsgarantie', '/flexibel-omruilen', '/vakantiegarantie'],
  KZ: ['/prisgaranti', '/fleksibel-og-gratis-aendring-af-rejse', '/rejser/sunweb-only'],
  QZ: ['/lagsta-prisgaranti', '/flexibel-ombokning', '/solresor/res-tryggt-med-sunweb'],
  FZ: ['/garantie-prix-le-plus-bas', '/echange-flexible', '/paiement-plusieurs-fois'],
  FS: ['/fr/garantie-prix-le-plus-bas', '/fr/echange-flexible', '/fr/aeroports'],
  BZ: ['/nl/laagste-prijsgarantie', '/nl/flexibel-omruilen', '/nl/vakantiegarantie'],
};

export function getSearchPageUSPs(publicationCode: PublicationCode): Usp[] | null {
  if (!SEARCH_PAGE_USPS[publicationCode]) {
    return null;
  }

  return [
    {
      translation: 'search_results_usp1',
      link: SEARCH_PAGE_USPS[publicationCode][0],
    },
    {
      translation: 'search_results_usp2',
      link: SEARCH_PAGE_USPS[publicationCode][1],
    },
    {
      translation: 'search_results_usp3',
      link: SEARCH_PAGE_USPS[publicationCode][2],
    },
  ];
}
